module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_tablet_d743d25bcefb0fab68c5d2b05093e714.png";